import { Card, Checkbox, Typography } from 'antd';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
    box-shadow: 0;
    transition: box-shadow 0.5s;
    &:hover {
        cursor: pointer;
        box-shadow: 0px 3px 7px #b5b3b3;
    }

    & .ant-card-body {
        padding: 16px;

        & .ant-card-meta-title {
            font-weight: 900;
        }
    }
`;

export const StatusContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
`;

export const ApplicationIdentifierContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    font-size: 15px;
`;

export const StyledAssigneeContainer = styled.span`
    margin: 10px 0px;
    font-size: 15px;
`;

export const StyledCheckbox = styled(Checkbox)`
    & .ant-checkbox {
        box-shadow: 0;
        transition: box-shadow 0.5s;
        &:hover {
            cursor: pointer;
            box-shadow: 0px 0px 3px var(--ant-primary-color);
        }
        & .ant-checkbox-inner {
            width: 1.5rem;
            height: 1.5rem;
            background-color: transparent;
            border-color: #e5e5e5;
        }

        & + span {
            padding-left: 1rem;
        }
    }

    & .ant-checkbox-checked > .ant-checkbox-inner {
        border-color: var(--ant-primary-color);

        &::after {
            border-width: 1px;
            border-color: var(--ant-primary-color);
            transform: rotate(45deg) scale(1, 1.5) translate(-50%, -50%);
        }
    }

    &.ant-checkbox-wrapper {
        font-size: 16px;
    }
`;

export const ApplicantName = styled(Typography)`
    font-size: 20px;
    font-weight: 700;
`;

export const ApplicationInfo = styled.div`
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const OthersInfoContainer = styled.div`
    margin-top: 20px;
`;

export const Content = styled.div`
    display: flex;
    align-items: center;
    font-size: 14px;
`;

export const ImageContainer = styled.div`
    display: flex;
    margin-right: 10px;
`;

export const Label = styled.label`
    color: #808080;
    margin-right: 10px;
`;
